import React from "react";

export const NoMatch = () => {
  return <div>404 Page</div>;
};
